// One token refresh in flight for the whole app.
//
// `api` and `newApi` talk to different backends but share one access token
// through tokenService. With a lock per module, both could rotate the refresh
// token at the same moment, and one of the two rotations would later present
// a token the other had already revoked. Both modules go through this lock.
let refreshPromise: Promise<string> | null = null;

export const isRefreshInFlight = (): boolean => refreshPromise !== null;

export const runExclusiveRefresh = (
  refresh: () => Promise<string>,
): Promise<string> => {
  if (refreshPromise) return refreshPromise;

  refreshPromise = refresh().finally(() => {
    refreshPromise = null;
  });

  return refreshPromise;
};

// The refreshed access token, whichever backend answered: backend-portal
// sends `token`, backend-senne sent only `accessToken`. Reading `token` alone
// left the portal on the old access token, so every request rotated again.
export const readRefreshedAccessToken = (
  data: { token?: string; accessToken?: string } | undefined,
): string | undefined => data?.token ?? data?.accessToken;
